"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotification = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var notistack_1 = require("notistack");
var Notification_1 = tslib_1.__importDefault(require("../Notification"));
var NotificationVariants_1 = require("../NotificationVariants");
exports.useNotification = function () {
    var snackbar = notistack_1.useSnackbar();
    var enqueueSnackbar = snackbar.enqueueSnackbar, closeSnackbar = snackbar.closeSnackbar;
    var queueMessage = function (_a) {
        var title = _a.title, message = _a.message, onExited = _a.onExited, _b = _a.variant, variant = _b === void 0 ? NotificationVariants_1.NotificationVariants.info : _b, actions = _a.actions, _c = _a.persist, persist = _c === void 0 ? true : _c;
        enqueueSnackbar(message, {
            preventDuplicate: true,
            onExited: onExited,
            persist: persist,
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            },
            content: function (key) { return (react_1.default.createElement(Notification_1.default, { title: title, id: key, message: message, variant: variant, actions: actions, onClose: closeSnackbar })); },
        });
    };
    return { queueMessage: queueMessage, closeMessage: closeSnackbar };
};
exports.default = exports.useNotification;
